import { Link } from 'react-router-dom';
import useScrollAnimation from '@/hooks/useScrollAnimation';

export default function CtaSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.08 });

  return (
    <section
      ref={ref}
      className="relative min-h-[100svh] flex flex-col items-center justify-center bg-background-100 overflow-hidden py-20 md:py-0"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20warm%20cream%20beige%20ivory%20tones%2C%20very%20subtle%20flowing%20organic%20shapes%2C%20minimalist%20and%20elegant%2C%20fine%20paper%20texture%2C%20gentle%20atmospheric%20light%2C%20clean%20and%20airy%20composition%2C%20sophisticated%20literary%20brand%20aesthetic%2C%20no%20text%2C%20high%20resolution%20editorial%20quality&width=1600&height=900&seq=muye-cta-bg-001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-100/85"></div>
      </div>

      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-accent-300/30 to-transparent z-10" />

      <div
        className={`relative z-10 flex flex-col items-center text-center px-6 md:px-10 w-full max-w-[800px] transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block text-5xl md:text-7xl font-heading text-accent-400 mb-6 opacity-60">
          &ldquo;
        </span>

        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6 text-balance">
          沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。
        </h2>

        <p className="text-foreground-500 text-sm md:text-base leading-relaxed mb-10 max-w-[560px] text-balance">
          正式出版書籍的書名、作者、ISBN、出版日期及完整書目資訊，可前往崧博出版書籍資料庫查詢。品牌經銷與合作方案詳情請直接聯繫洽詢。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/stores"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            合作通路
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 text-sm font-medium rounded-full hover:bg-secondary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            常見問答
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}